import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useInView } from 'react-intersection-observer';

import { legacyTheme, styled } from '@prose-ui/legacy';
import { makeStyles } from 'legacyStyles';

import BlogCard from 'Components/BlogCard';
import { Typography } from 'Components/Typography';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import BlockLayout from './BlockLayout';

const BlogCards = styled.section`
  display: flex;
  flex-flow: row;
  align-content: center;
  justify-content: space-around;
  width: 100%;
  max-width: 1200px;
  margin-top: 50px;

  ${legacyTheme.breakpoints.match('sm')} {
    flex-flow: column;
    align-items: center;
    justify-content: center;
  }
`;

const useStyles = makeStyles(() => ({
  appear: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: 'opacity 300ms ease-in',
  },
}));

const BlogBlock = ({ backgroundColor, content: { title, subtitle, content } }) => {
  const [ref, inView] = useInView({
    /* Optional options */
    threshold: 0.13,
    triggerOnce: true,
  });
  const { classes } = useStyles();

  return (
    <BlockLayout
      ref={ref}
      backgroundColor={backgroundColor}
      classes={{ content: classNames(classes.appear, { [classes.visible]: inView === true }) }}
      contentWidth="veryWide"
    >
      <Typography align="center" variant="mono1">
        {title}
      </Typography>

      <br />

      <Typography align="center" color="grey" variant="p1">
        {subtitle}
      </Typography>

      <BlogCards>
        {content.map(article => (
          <BlogCard
            key={article.title}
            category={article.category}
            image={article.image}
            imageAlt={article.title}
            subtitle={article?.subtitle}
            title={article.title}
            url={article.url}
          />
        ))}
      </BlogCards>
    </BlockLayout>
  );
};

BlogBlock.propTypes = {
  backgroundColor: PropTypes.string,
  content: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]).isRequired,
    subtitle: PropTypes.string.isRequired,
    content: PropTypes.arrayOf(
      PropTypes.shape({
        image: srcOrNextImageProp.isRequired,
        category: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

BlogBlock.defaultProps = {
  backgroundColor: 'beige',
};

export default BlogBlock;
